import { render, staticRenderFns } from "./RequestAttachments.vue?vue&type=template&id=29b21a2e&"
import script from "./RequestAttachments.vue?vue&type=script&lang=js&"
export * from "./RequestAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports